import { errorStatusMessage } from './errorStatusMessage';
import { sportHistory } from './sportHistory';
import { reports } from './reports';

export const locale = {
  ...errorStatusMessage,
  reports,
  sportHistory,
  change: 'Cambiar',
  changePassword: 'Cambiar contraseña',
  logout: 'Cerrar sesión',
  transferOfFunds: 'Transferencia de fondos',
  withdrawalOfFunds: 'Retiro de fondos',
  access: 'Acceder',
  agentPlatfrom: 'Plataforma de agentes',
  email: 'Correo electrónico',
  password: 'Contraseña',
  login: 'Usuario',
  other: 'Los demás',
  username: 'Nombre de usuario',
  language: 'Idioma',
  confirmNewPassword: 'Confirmar nueva contraseña',
  changeMyPassword: 'Cambiar mi contraseña',
  statuses: {
    1: 'Ganado',
    2: 'Perdido',
    3: 'Espera',
  },
  statusesForPayment: { 1: 'Confirmado' },
  generalReport: 'Informe General',
  depositsAndWithdrawals: 'Depositos/Retiros Jugadores',
  playerAndAgentDetail: 'Detalles de jugadores y agentes',
  agents: 'Agentes',
  agent: 'Agente',
  confirmPassword: 'Confirmar contraseña',

  emtretenimiento: 'Somos emtretenimiento',

  users: 'Usuarios',
  seeAll: 'Ver todo',
  seeAgents: 'Ver agentes',
  seePlayers: 'ver jugadores',
  createAgent: 'Crear agente',
  createPlayer: 'Crear jugador',
  financialReports: 'Reportes financieros',
  general: 'General',
  cashDepositsWithdrawals: 'Efectivo (depósitos y retiros)',
  playerReports: 'Informes de jugadores',
  playerHistory: 'Historial de jugadores',
  detailByPlayer: 'Detalle por jugador',
  sportsBets: 'Apuestas Deportivas',
  finance: 'Finanzas',
  myDebtAccount: 'Depositos/Retiros Agentes',
  accountBalance: 'Saldo de la cuenta',
  howToStart: 'Cómo empezar',

  search: 'Buscar',
  newAgent: 'Nuevo agente',
  newPlayer: 'Nuevo jugador',
  player: 'Jugador',

  allUsers: 'Todos usuarios',
  players: 'Jugadores',
  disabled: 'Desactivado',
  user: 'Usuario',
  balance: 'Saldo',
  operations: 'Operaciones',
  actions: 'Acciones',
  records: 'Registros',
  recordsOnPage: 'Mostrar en la página',
  elementsOnPage: 'Elementos en la página',
  balanceSort: 'Ordenar por balance',
  none: 'Sin ordenar',
  moreToLess: 'De mayor a menor',
  lessToMore: 'De menor a mayor',
  aToz: 'A to Z',
  zToa: 'Z to A',
  withdrawal: 'Retirar',
  deposit: 'Depositar',
  toDeposit: 'Depósito',
  topup: 'Depositar',
  cancel: 'Cancelar',
  save: 'Guardar',
  processing: 'Tratamiento...',

  name: 'Nombre',
  filter: 'Filtro',
  acceptFilter: 'Aplicar filtro',

  surname: 'Apellido',
  withdrawalAllowed: 'Permitir <span>retiros</span> para sus agentes y jugadores',
  depositAllowed: 'Permitir <span>depósitos</span> para sus agentes y jugadores',
  onlyPlayerCreationAllowed: 'Permitir la <span>creación</span> de solo jugadores',
  createSuccess: 'Éxito',

  disable: 'Bloquear',
  edit: 'Editar',
  userEdit: 'Editar',
  informations: 'Información',
  id: 'ID',
  accept: 'Aceptar',
  disableUser: 'Bloquear Usario',
  acceptDisableUser: 'Sí, bloquearlo',
  acceptEnableUser: 'Sí, habilitar usuario',
  disableDescription: 'Está seguro de que desea bloquear el jugador con el nombre',
  enableDescription: 'Está seguro de que desea habilitar el reproductor <br/> con nombre de usuario',

  modifyAgent: 'Modificar agente',
  information: 'Información',
  hierachy: 'jerarquía',
  currency: 'Moneda',
  creationDate: 'Fecha de creación',
  modificationDate: 'Fecha de modificación',
  enable: 'Habilitar',
  enableUser: 'Habilitar usuario',
  close: 'Cerrar',
  noResults: 'No se han encontrado resultados',

  today: 'Hoy',
  yesterday: 'Ayer',
  lastWeek: 'La semana pasada',
  lastMonth: 'El mes pasado',
  dateFrom: 'De',
  dateTo: 'A',
  local: 'Local',
  addDays: 'Mostrar todas',
  utc: 'UTC',
  dateUntil: 'Fecha hasta',
  help: 'Ayuda',
  show: 'Mostrar',
  directOnly: 'Solo directos',
  timeZoneMsg:
    'La zona horaria local tiene en cuenta la fecha y la hora que ha configurado en su dispositivo. La zona horaria UTC 00:00 es un estándar de tiempo universal. Si selecciona la opción "Local", se tendrá en cuenta la hora de su país, y si selecciona la opción "UTC", se tendrá en cuenta la hora estándar universal.',
  10: '10',
  total_bet_count: 'Recuento total de apuestas',
  total_bet: 'Apuesta total',
  total_won: 'Total ganado',
  betCount: 'Recuento de apuestas',
  betAmount: 'Monto de la apuesta',
  commission_balance: 'Comisión',
  winAmount: 'Cantidad ganada',
  provider: 'Proveedor',

  compare: 'Comparar',
  standardValues: 'Valores estándar',
  precedingDay: 'Día anterior',
  sameDayLastWeek: 'Mismo día de la semana pasada',
  sameDayLastMonth: 'Mismo día del mes pasado',
  precedingWeek: 'Semana anterior',
  fourWeeksAgo: 'Hace cuatro semanas',
  sameWeekLastMonth: 'Misma semana del mes pasado',
  precedingMonth: 'Mes anterior',
  samePeriodLastYear: 'Mismo período del año pasado',
  manualCompare: 'Comparación manual',
  margin: 'Margin',

  searchIn: 'Busca en',
  higher: 'Más alto',
  transaction: 'Transacción',
  date: 'Fecha',
  operation: 'Operación',
  transitionType: 'Tipo de transición',
  agentInitiator: 'Agente iniciador',
  initiator: 'Iniciador',
  destinationAgent: 'Agente de destino',

  reportsGeneral: 'Informes generales',
  playerReportsGeneral: 'Informes de jugadores generales',
  sportBets: 'Apuestas Deportivas',
  amountIn: 'Depositado',
  amountOut: 'Retirado',
  total: 'Balance actual',
  totalSaldo: 'Total',
  byProvider: 'Por proveedor',
  myOperations: 'Mis operaciones',
  result: 'Resultado',

  gameType: 'Tipo de juego',
  statusBet: 'Apuesta de estado',
  type: 'Tipo',
  win: 'Ganado',
  bet: 'Apuesta',
  refund: 'Reembolso',
  liveCasino: 'Casino en vivo',
  virtualGames: 'Juegos virtuales',
  all: 'Todos',
  slots: 'Tragamonedas',
  prevBalance: 'Saldo antes',
  balanceAfter: 'Saldo después',
  balanceBefore: 'Saldo antes',
  prevBefore: 'Saldo ante',
  afterBalance: 'Saldo después',
  userId: 'Identificación de usuario',
  couponId: 'identificación del cupón',
  wait: 'En espera',
  return: 'Devuelto',
  loss: 'Pérdida',
  sold: 'Vendido',
  isExpress: 'es expreso',
  createdAt: 'Creado en',
  totalCoeff: 'coeficiente total',
  fromUser: 'Del usuario',
  toUser: 'Al usuario',
  from: 'De',
  to: 'A',

  subagents: 'Subagentes',
  newPassword: 'Nueva contraseña',
  oldPassword: 'Contraseña actual',
  repeatPassword: 'Repita la contraseña',
  passwordsDontMatch: '¡Las contraseñas no coinciden!',

  changePermissions: type => `Edición de permisos: ${type} `,
  changePermissionsCasino: 'Permission edit: Casino',
  changePermissionLiveCasino: 'Permission edit: Live Casino',
  changePermissionSport: 'Permission edit: Sport',
  showTheSelectedCategoryForUser: 'Mostrar la categoría seleccionada para el usuario',
  permissionsDetails: 'Detalles de permisos',
  casino: 'Casino',
  sport: 'Deportivas',
  permissions: 'Permisos',
  copyPermissions: 'Copiar permisos a usuarios secundarios',

  total_income: 'Ingreso total',
  incomeAmount: 'Netwin',
  commissionBalance: 'Comisión',
  myCommissionBalance: 'Mi comisión',
  enterTextInLowercaseOnly: 'Introducir texto sólo en minúsculas',

  userNotFound: 'Usuario no encontrado. Compruebe sus credenciales y vuelva a intentar de nuevo.',

  wantToCreateAgent: 'Está seguro, <br/> que quiere crear',
  wantToCreatePlayer: 'Está seguro, <br/> que quiere crear',

  or: 'O',
  retirement: 'Retiro',
  totalDeposit: 'Total depósitos',
  totalWithdrawal: 'Total retiros',
  editAccount: 'Edit account',
  player_agent: 'Jugator/Agente',
  typeOnlyLowercase: 'Introducir texto solo en minusculas',
  resetFilter: 'Restablecer filtro',
  hide: 'Ocultar',
  tree: 'Árbol',
  black: 'Negro',
  gold: 'Oro',
  silver: 'Plata',
  bronze: 'Bronce',
  loadOperations: 'Cargar operaciones',

  all1: 'Todo',
  lastCasinoBets: 'Últimas apuestas de casino',
  deposits: 'Depósitos',
  withdrawals: 'Retiros',
  myCount: 'Movimientos de/a mi cuenta',
  ip: 'IP',
  enterAmount: 'Ingrese la cantidad',
  doYouWantToDepositABonus: '¿Quieres depositar un bono?',
  percent: 'Por ciento %',
  bonus: 'Bonus',
  dataWillBeUpdated: 'Los datos se actualizarán pronto',
  lastUpdateTime: 'La última actualización de los datos',
  currentWeek: 'Semana actual',
  currentMonth: 'Mes actual',

  paymentStatuses: {
    0: 'Depósito',
    1: 'Retiro',
  },
  notification: 'Notificación',
  new: 'Nuevo',
  attention: 'Atención',
  showAll: 'Mostrar todo',
  lastYear: 'El año pasado',

  playerDeposits: 'Peticiones de jugadores',
  requisites: 'Requisitos',
  editRequisites: 'Editar requisitos',
  cbu: 'CBU',
  amount: 'Cantidad',
  comment: 'Comentario',
  nameUsers: 'Titular de tu billetera',
  action: 'Acción',
  notes: 'Notas',
  betId: 'Apuesta ID',
  balanceActual: 'Saldo real',
  phone: 'Teléfono',
  advertising: 'PUBLICIDAD',
  copiedSuccessfully: `Copiado con éxito`,
  parentID: 'Parent ID',

  bankDetails: 'Datos bancarios',
  minimalDeposit: 'Depósito mínimo',
  deleteBankDetails: 'Eliminar datos bancarios',
  details: 'Detalles',
  bank: 'Banco',
  additionalInfo: 'Información adicional',
  owner: 'Propietario',
  semiAutoWithdrawalEnabled: '<span>Depósito</span> y <span>retirada</span> semiautomáticos',
  contactWithPlayers: 'Contacto con los jugadores',

  // statistic
  myStatistic: 'Mis Estadísticas',
  totalWin: 'Ganacias totales',
  totalNetwin: 'Ingreso total',
  myAgents: 'Mis agentes',
  myPlayers: 'Mis jugadores',
  playerBalance: 'Saldo de jugadores',
  agentBalance: `Saldo de agentes`,
  number: 'Número',
  netwin: 'Netwin',
  bets: 'Apuestas',
  wins: 'Ganancias',
  totalBets: 'Apuestas totales',
  activeUser: 'Usuarios activos',
  activeNewUsers: 'Nuevo usuario activo',
  newUsers: 'Nuevo usuario',
  noResultsFound: 'No se han encontrado resultados',

  // request history
  requestHistory: 'Historial de peticiones',
  whatsapp: 'Whatsapp',
  holderOfYourWallet: 'Titular de tu billetera',
  generateStrongPassword: 'Generar contraseña fuerte',

  changePasswordFirsLog: 'Aviso importante: Por favor, actualice su contraseña',
  securePassword: 'Generar una contraseña segura',

  referralPlayers: 'Jugadores de referencia',
  invitePlayer: 'Invitar a un jugador',
  referralCodeNotFound: 'Código de referencia no encontrado',
  promotionLinkNotFound: 'Enlace de promoción no encontrado',
  addFeedbackLink: 'Agregar enlace de contacto',
  addPromotionLink: 'Añadir promoción',
  contactLinkText: 'Agregá un enlace para que los jugadores puedan contactarte directamente',
  link: 'Link',

  cashbackHistory: 'Historial de cashback',
  activateCashback: 'Activar cashback',
  deactivateCashback: 'Desactivar cashback',
  cashbackTerms: 'Términos de cashback y condiciones',
  paidCashback: 'Cashback pagado',
  accumulatedCashback: 'Cashback acumulado',
  cashbackToBePaid: 'Cashback a pagar',
  activateForItsUsers: 'Activar para sus usuarios',
  activateForEntireStructure: 'Activar para toda la estructura',
  deactivateForItsUsers: 'Desactivar para sus usuarios',
  deactivateForEntireStructure: 'Desactivar para toda la estructura',
  playersOnly: 'Solo jugadores',
  agentOnly: 'Solo agentes',
  areYouSureYouWantToActivateCashback: '¿Estás seguro de querer activar el cashback?',
  yes: 'Sí',
  no: 'No',
  promoCodePercent: 'Código promocional aplicado. Bonificación del <percent>% sobre el monto del depósito',
  giftNotFound: 'Regalo no encontrado',

  nameGift: 'Nombre del regalo',
  numberOfPoints: 'Número de puntos',
  promocodeAmount: 'Código promocional / cantidad',
  status: 'Estado',
  active: 'Activo',
  disable: 'Desactivar',
  image: 'Imagen',
  load: 'Carga',
  description: 'Descripción',
  noMore30: 'No más de 30 caracteres',
  playerLevel: 'Nivel del jugador',
  jugador: 'Jugador',
  bronce: 'Bronce',
  plata: 'Plata',
  oro: 'Oro',
  vip: 'VIP',
  typeOfPrize: 'Tipo de premio',
  promocode: 'Código promocional',
  balance: 'Balance',
  real: 'Real',
  other: 'Otro',
  fileSizeExceed: 'El tamaño del archivo supera los 40 kB, por favor seleccione otro archivo.',
  hasNoFiles: 'No se encontraron archivos.',
  disable2: 'Desactivar',
  points: 'Puntos',
  giftManagement: 'Gestión de regalos',
  imageLoadError: 'Error al cargar la imagen\n<url>',
  delete: 'Borrar',
  bonusProgram: 'Programa de bonificación',
  create: 'Crear',
};
